// extracted by mini-css-extract-plugin
module.exports = {"btnStyle":"style_btnStyle___YUoh"};